import {
  EVENT_ASSETS_FETCH_START,
  EVENT_ASSETS_FETCH_FAIL,
  EVENT_ASSETS_FETCH_SUCCESS,
  UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER,
} from '../constants/event.actionTypes'

const initialState = {
  data: [],
  aggregation: {
    listing_status: {},
    location: {
      states: [],
      counties: [],
      cities: [],
    },
  },
  total: 0,
  count: 0,
  offset: 0,
  fetchAssetsProgress: {
    loading: true,
    errors: null,
  },
}

const assetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case EVENT_ASSETS_FETCH_START: {
      return Object.assign({}, state, {
        fetchAssetsProgress: {
          loading: true,
          errors: null,
        },
      })
    }
    case EVENT_ASSETS_FETCH_FAIL: {
      return Object.assign({}, state, {
        fetchAssetsProgress: {
          loading: false,
          errors: action.error,
        },
      })
    }
    case EVENT_ASSETS_FETCH_SUCCESS: {
      const {
        total_count: total,
        size: count,
        content: data,
        offset,
        aggregation,
      } = action.value

      return Object.assign({}, state, {
        fetchAssetsProgress: {
          loading: false,
          errors: null,
        },
        data,
        total,
        count,
        offset,
        aggregation,
      })
    }

    case UPDATE_PROPERTIES_SAVED_STATE_FOR_NEWLY_AUTHENTICATED_USER: {
      const savedPropertyIds = new Set(action.currently_saved_property_ids)

      const data = state.data.map(listing => {
        const propertyId = listing.primary_property.property_id

        return savedPropertyIds.has(propertyId)
          ? {
              ...listing,
              primary_property: {
                ...listing.primary_property,
                is_currently_saved: true,
              },
            }
          : listing
      })

      return { ...state, data }
    }

    default:
      return state
  }
}

export default assetsReducer
export { initialState }
